import { render, staticRenderFns } from "./DActivateSwitch.vue?vue&type=template&id=8881aa12&scoped=true&"
import script from "./DActivateSwitch.vue?vue&type=script&lang=js&"
export * from "./DActivateSwitch.vue?vue&type=script&lang=js&"
import style0 from "./DActivateSwitch.vue?vue&type=style&index=0&id=8881aa12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8881aa12",
  null
  
)

export default component.exports